
import NavigationTabBar from '@/layouts/components/NavigationTabBar.vue'
import NavigationTabBarItem from '@/layouts/components/NavigationTabBarItem.vue'
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs, watch,
} from 'vue'
import { useStore } from 'vuex'
import { useQuasar } from 'quasar'
import useContentModule, { Mutation } from '@/pages/composables/useContentModule'
import { CtSupplier, CtSupplierCatalogue } from '@/models/interfaces/content-type'
import AddIcon from '@/components/Icons/AddIcon.vue'
// import ChannelDetails from '@/pages/Channels/components/ChannelDetails.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import { useRoute, useRouter } from 'vue-router'
import DButton from '@/components/base/DButton.vue'
import DButtonToggle from '@/components/base/DButtonToggle.vue'
import SupplierCatalogueDetails from '@/pages/WIP/components/SupplierCatalogueDetails.vue'

import SelectHeader from '@/components/SelectHeader.vue'
import { DirectrEvent } from '@/services/directr'

export default defineComponent({
  name: 'SupplierCatalogueOverview',
  props: {
    supplierCatalogueId: {
      type: String,
      required: false,
    },
  },
  components: { TrashIcon, AddIcon, NavigationTabBarItem, NavigationTabBar, DButton, DButtonToggle, SupplierCatalogueDetails, SelectHeader },
  setup (props) {
    const $store = useStore()
    const $q = useQuasar()
    const $directr = $store.getters['Services/Directr']
    const $router = useRouter()

    const state = reactive({
      activeTab: 'Supplier Catalogue',
      packing: [],
      storageTypes: [],
      entryConfig: computed(() => $store.getters['View/EntryConfig']),
      itemConfig: computed(() => $store.getters['View/Itemconfig']),
    })

    const { items, active, model, loading, contentType, fetch, mutate, setActive, requestHandler } = useContentModule<CtSupplierCatalogue>('SupplierCatalogue', $store)

    const supplierCatalogues = items

    onMounted(() => {
      $directr.listen(DirectrEvent['Create/SupplierCatalogue'], (event) => {
        if (!event?.payload) return
        mutate(event?.payload, Mutation.create)
      })
      $directr.listen(DirectrEvent['Update/SupplierCatalogue'], (event) => {
        if (!event?.payload) return
        mutate(event?.payload, Mutation.update)
      })
    })

    const setActiveSupplierCatalogue = ($event) => {
      setActive(supplierCatalogues.value.find(c => c.sys.id === $event))
    }
    void fetch([], { limit: 100, resolve: 1 }).catch(console.error).then(() => {
      watch(() => props.supplierCatalogueId, (newValue) => {
        if (newValue) {
          setActiveSupplierCatalogue(newValue)
        } else if (supplierCatalogues.value?.length) {
          const firstSupplierCatalogueId = supplierCatalogues.value.find(s => s.name)?.sys.id
          if (firstSupplierCatalogueId) void $router.push({ name: 'SupplierCatalogues', params: { supplierCatalogueId: firstSupplierCatalogueId } })
        }
      })
      watch(() => active.value, (newValue) => {
        if (!newValue) return
        if (newValue?.sys?.id !== props.supplierCatalogueId) {
          void $router.push({ name: 'SupplierCatalogues', params: { supplierCatalogueId: newValue.sys.id } })
        }
      })
      if (props.supplierCatalogueId) {
        setActiveSupplierCatalogue(props.supplierCatalogueId)
      } else if (supplierCatalogues.value?.length) {
        const firstSupplierCatalogueId = supplierCatalogues.value.find(s => s.name)?.sys.id
        if (firstSupplierCatalogueId) void $router.replace({ name: 'SupplierCatalogues', params: { supplierCatalogueId: firstSupplierCatalogueId } })
      }
    })

    const onSupplierClick = () => {
      if (active.value?.supplier) {
        void $router.push({ name: 'Suppliers', params: {
          supplierId: typeof active.value.supplier === 'object' ? (active.value.supplier as any)?.sys?.id : active.value.supplier,
          supplierCatalogueId: props.supplierCatalogueId
        }})
      } else {
        void $router.push({ name: 'Suppliers', params: { supplierCatalogueId: props.supplierCatalogueId }})
      }
    }

    requestHandler.get(
      'packing', [{ select: ['__id', 'name'] }]
    ).then(({ items = [] }) => state.packing = items).catch(console.error)

    requestHandler.get(
      'storage_type', [{ select: ['__id', 'id'] }]
    ).then(({ items = [] }) => state.storageTypes = items).catch(console.error)

    const saveSupplierCatalogue = async (sysId, savePayload) => {
      // console.log('save', sysId, savePayload)
      const response = await requestHandler.put(contentType, [sysId], savePayload)
      mutate(response)
      setActiveSupplierCatalogue(sysId)
    }

    const savePacking = () => {
      // pass
    }

    function createSupplierCatalogue (name) {
      // console.log('createSupplierCatalogue', name)
      return $directr.put('supplier_catalogue', [], { name })
        .then(({ items: [supplierCatalogue] }) => {
          mutate(supplierCatalogue, Mutation.create)
          active.value = supplierCatalogue

          $q.notify({type: 'positive', classes: 'custom-notify success', message: 'New supplier catalogue created'})
          return supplierCatalogue
        }).catch(e => {
          console.error(e)
          $q.notify({ type: 'negative', message: 'Something went wrong wile creating the supplier catalogue', classes: 'custom-notify error'})
        })
    }

    const addSupplierCatalogue = () => {
      $q.dialog({
        title: 'Create a new supplier catalogue',
        message: 'Please enter a supplier cataloge name',
        prompt: {
          model: '',
          type: 'text',
          isValid: val => Boolean(val.length),
        },
        cancel: true,
      }).onOk((name) => {
        $directr.put('supplier_catalogue', [], { name })
        .then(({ items: [supplierCatalogue] }) => {
          mutate(supplierCatalogue, Mutation.create)
          // console.log('created', supplierCatalogue)
          setActive(supplierCatalogue)
        }).catch(console.error)
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }

    const deleteSupplierCatalogue = () => {
      const activeCatalogue = active.value
      if (!activeCatalogue) return
      $q.dialog({
        title: `Delete supplier catalogue ${ activeCatalogue?.name } (${ activeCatalogue?.sys.id })?`,
        message: 'Are you sure?',
        cancel: true,
        persistent: false
      }).onOk(() => {
        if (!activeCatalogue) return
        $directr.delete(activeCatalogue.sys.id)
        .then(() => {
          if (!activeCatalogue) return
          const activeIndex = supplierCatalogues.value.findIndex(c => c?.sys?.id === activeCatalogue?.sys?.id)
          if (activeIndex + 1 < supplierCatalogues.value.length) {
            setActive(supplierCatalogues.value[activeIndex + 1])
          } else if (activeIndex > 0) {
            setActive(supplierCatalogues.value[activeIndex - 1])
          } else {
            active.value = null
          }
          mutate(activeCatalogue, Mutation.remove)
        })
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }

    return {
      ...toRefs(state),
      active,
      loading,
      setActiveSupplierCatalogue,
      saveSupplierCatalogue,
      savePacking,
      supplierCatalogues,
      mutate,
      Mutation,
      requestHandler,
      createSupplierCatalogue,
      addSupplierCatalogue,
      deleteSupplierCatalogue,
      onSupplierClick,
      notify: message => {
        $q.notify({ message, position: 'top', classes: 'custom-notify' })
      },
    }
  }
})
